import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import Icon from './Icon';
import theme from '../styles/theme';
import { StyledText, TextSize } from './Text';

type Props = {
  name: string;
  to: any;
  margin: number;
  icon: string;
  disable: boolean;
  customStyle?: Object;
  children?: any;
  isMain?: boolean;
  fontSize: string;
  click?: any;
  isDropDown?: boolean;
  isSignOut?: boolean;
  isOpen: boolean;
};
const SideStyled = styled(StyledText)`
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  line-height: 25px;
  align-self: center;
`;

const ActiveStyled = styled.div`
  width: 100%;
  &:hover {
    background-color: inherit;
    border-radius: ${({ theme }) => theme.radius};
  }
`;

function SidebarMenuItem({
  name,
  to,
  margin,
  disable,
  icon,
  children = null,
  fontSize,
  isMain = false,
  click,
  isDropDown = false,
  isSignOut,
  isOpen,
}: Props): JSX.Element {
  let style = {
    textDecoration: 'none',
    padding: '8px 8px',
    alignContent: 'center',
    textoverflow: 'clip',
    display: 'flex',
    color: theme.color.lightBlueGray600,
    borderRadius: '4px',
    margin: '4px 0px',
  };
  let disableStyle = {
    textDecoration: 'none',
    padding: '8px 8px',
    alignContent: 'center',
    textoverflow: 'clip',
    display: 'flex',
    color: 'rgb(71 85 105 / 41%)',
    cursor: 'default',
    borderRadius: '4px',
    margin: '4px 0px',
  };
  let activeStyle = {
    textDecoration: 'none',
    padding: '8px 8px',
    alignContent: 'center',
    textoverflow: 'clip',
    display: 'flex',
    color: theme.color.lightBlueGray50,
    background: theme.color.blueButton,
    boxShadow: '0px 6px 35px rgba(0, 0, 0, 0.12)',
    borderRadius: '4px',
    margin: '4px 0px',
  };
  const appendStyle = { justifyContent: 'space-between', whiteSpace: 'nowrap' };

  if (isDropDown) {
    style = { ...style, ...appendStyle };
  }
  if (isOpen) {
    style = { ...style, padding: '6px 12px' };
    activeStyle = { ...activeStyle, padding: '6px 12px' };
  } else {
    style = { ...style, padding: '8px 12px' };
    activeStyle = { ...activeStyle, padding: '8px 12px' };
  }
  return (
    <ActiveStyled onClick={click}>
      <NavLink
        to={to}
        onClick={(e) => { disable ? e.preventDefault() : localStorage.removeItem('competencies') }}
        style={({ isActive }) => (window.location.pathname.includes(to) ? activeStyle : disable ? disableStyle : style)}>
        <SideStyled textSize={TextSize.sidebar}>
          <Icon style={{ verticalAlign: 'middle' }} mr={margin} name={icon} />
        </SideStyled>
        {isOpen && <SideStyled textSize={TextSize.sidebar}>{name}</SideStyled>}
        {children}
      </NavLink>
    </ActiveStyled>
  );
}

export default React.memo(SidebarMenuItem);
